/**
 * `components.MuiAvatar` — rounded variant and border/fill styling.
 * Discoverability: `MuiAvatar`, `Avatar`, `variant: 'rounded'`.
 *
 * @see https://mui.com/material-ui/api/avatar/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiAvatar(theme: Theme): Pick<Components<Theme>, 'MuiAvatar'> {
  return {
    MuiAvatar: {
      variants: [
        {
          props: { variant: 'rounded' },
          style: {
            border: `1px solid ${theme.palette.border.light}`,
            borderRadius: 8,
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
          },
        },
      ],
    },
  };
}
